export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  CREATE_PIN: '/create-pin',
  FORGOT_PIN: '/forgot-pin',
  DASHBOARD: '/dashboard',
  /** Deep-link from email View Task — opens Edit Task drawer */
  TASK_DETAIL: '/tasks/:taskId',
  PROFILE: '/profile',
  EMPLOYEES: '/employees',
  TASK_IMPORT: '/tasks/import',
  SUPPORT_GUIDE: '/support',
  POLLS: '/polls',
  POLLS_ALL: '/polls/all',
  POLL_ADMINS: '/polls/admins',
  POLL_NEW: '/polls/new',
  POLL_EDIT: '/polls/:pollId/edit',
  POLL_RESULTS: '/polls/:pollId/results',
  PUBLIC_POLL: '/poll/:publicId',
  PRIVACY_POLICY: '/privacy-policy',
} as const;

export function pollEditPath(pollId: string): string {
  return `/polls/${pollId}/edit`;
}

export function pollResultsPath(pollId: string): string {
  return `/polls/${pollId}/results`;
}

export function publicPollPath(publicId: string): string {
  return `/poll/${publicId}`;
}

export function taskDetailPath(taskId: string): string {
  return `/tasks/${taskId}`;
}
